import { styled,  withStyle } from "baseui";

const TimelineItem = (props: any) => {

    const ContentItem = props.evenOdd ? TimelineItemContent : TimelineItemContentOdd;
    const CircleItem = props.evenOdd ? Circle : CircleOdd;
    const ArrowItem = props.evenOdd ? Arrow : ArrowOdd;

    return (
        <TimelineItemContainer>
            <ContentItem $backgroundColor={props.backgroundColor}>
                {props.children}
                <ArrowItem $backgroundColor={props.backgroundColor}></ArrowItem>
            </ContentItem>
            <CircleItem></CircleItem>
        </TimelineItemContainer>
    );
}
export default TimelineItem;

const TimelineItemContent = styled<'div',{$backgroundColor: string | undefined}>("div", ({ $backgroundColor, $theme }) => ({
    boxShadow: '0 0 5px hsla(0, 0%, 0%, 0.16)',
    borderRadius: $theme.sizing.scale200,
    backgroundColor: $backgroundColor ?? $theme.colors.backgroundSecondary,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    padding: $theme.sizing.scale600,
    position: 'relative',
    width: '400px',
    maxWidth: '70%',
    textAlign: 'right'
}));

const TimelineItemContentOdd = withStyle(TimelineItemContent, ({ $theme }) => ({
    alignItems: 'flex-start',
    textAlign: 'left',
}));

const TimelineItemContainer = styled("div", {
    display: 'flex',
   // background: '#f1f1f1',
    justifyContent: 'flex-end',
    position: 'relative',
    width: '50%',
    flexDirection: 'row',
    margin: '5px 0 0 -28px',
    ":nth-child(odd)": {
        alignSelf: 'flex-end',
        justifyContent: 'flex-start',
        margin: '5px -28px 0 0',
    }
});

const Circle = styled("span", ({ $theme }) => ({
    backgroundColor: $theme.colors.accent100,
    border: '2px solid #276EF1',
    borderRadius: '50%',
    position: 'absolute',
    top: `calc(50% - 10px)`,
    width: '20px',
    height: '20px',
    right: `-40px`,

}));

const CircleOdd = withStyle(Circle, ({ $theme }) => ({
    left: `-40px`
}));


const Arrow = styled<'div',{$backgroundColor: string | undefined}>("div", ({ $backgroundColor, $theme }) => ({
    content: ' ',
    backgroundColor: $backgroundColor ?? $theme.colors.backgroundSecondary,
    boxShadow: `1px -1px 1px hsla(0, 0%, 0%, 0.08)`,
    position: 'absolute',
    right: '-7.5px',
    top: 'calc(50% - 7.5px)',
    transform: 'rotate(45deg)',
    width: '15px',
    height: '15px',
}));

const ArrowOdd = withStyle(Arrow, ({ $theme }) => ({
    right: 'auto',
    left: '-7.5px',
    boxShadow: '-1px 1px 1px hsla(0, 0%, 0%, 0.08)'
}));
